<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="ការដាក់ប្រាក់ទាំងអស់" name="first"></el-tab-pane>
			<!-- <el-tab-pane label="ដាក់ប្រាក់ជោគជ័យ" name="second"></el-tab-pane>
			<el-tab-pane label="បដិសេធដាក់ប្រាក់" name="third"></el-tab-pane> -->
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ លេខកូដប្រតិបត្តិការ ឈ្មោះអតិថិជន</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្ថានភាពប្រតិបត្តិការ</label>
						<md-select placeholder="ស្ថានភាពប្រតិបត្តិការ (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option :value="0">រង់ចាំដាក់ប្រាក់</md-option>
							<md-option :value="1">ដាក់ប្រាក់ជោគជ័យ</md-option>
							<md-option :value="2">បដិសេធដាក់ប្រាក់</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-30 md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table v-if="depositList.length > 0">
				<md-table-row>
					<!-- <md-table-head>ល.រ</md-table-head> -->
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដប្រតិបត្តិការ</md-table-head>
					<md-table-head>ចំនួនទឹកប្រាក់</md-table-head>
					<md-table-head>អតិថិជន</md-table-head>
					<md-table-head>អ្នកអនុម័ត</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(deposit, index) in depositList">
					<md-table-cell>{{index+1}}</md-table-cell>
					<md-table-cell><b>{{deposit.id}}</b><br>{{config.datelify(deposit.created_date)}} ({{config.timelify(deposit.created_date)}})</md-table-cell>
					<md-table-cell><b>{{config.moneylify(deposit.amount)}}</b><br>{{deposit.payment_type}}</md-table-cell>
					<md-table-cell><b>{{deposit.username}} <md-icon class="verify" v-if="deposit.verified == 1">verified</md-icon> ({{config.moneylify(deposit.balance)}})</b><br>{{deposit.name}}</md-table-cell>
					<md-table-cell>
						<span v-if="deposit.approve_by != null"><b>{{deposit.approve_by}}</b><br>{{config.datelify(deposit.approved_date)}} ({{config.timelify(deposit.approved_date)}})</span>
						<span v-else><b>មិនមាន</b></span>
					</md-table-cell>
					<md-table-cell>
						<span class="late" v-if="deposit.status == 0">{{ config.getDepositStatus(deposit.status) }}</span>
						<span class="green" v-if="deposit.status == 1">{{ config.getDepositStatus(deposit.status) }}</span>
						<span class="error" v-if="deposit.status == 2">{{ config.getDepositStatus(deposit.status) }}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/deposits/detail/' + deposit.id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលំអិត</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>

				</md-table-row>
			</md-table>
			<h4 class="text-center" v-if="depositList.length == 0 && loadMore == true">មិនមានកញ្ចប់ឥវ៉ាន់</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>


		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់នេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់កញ្ចប់ឥវ៉ាន់នេះត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប"
			md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="onDelete" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.interval = setInterval(() => {
				this.searchHandler();
			}, 15000)
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					status: ""
				},
				interval: null,
				loadMore: false,
				depositList: []

			}
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/deposit/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.depositList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.depositList = more ? this.depositList.concat(data.body.data) : data.body.data;
				})
			},

			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {

				this.loan.client_id = "";
				this.loan.client = [];
			},
			printLabel(pkg) {
				let hash_id = pkg.hash_id;
				let tracking = pkg.tracking;
				let driver_phone = encodeURIComponent(pkg.driver_phone || "មិនមាន");
				let client_name = encodeURIComponent(pkg.client_name || "មិនមាន");
				let receiver_phone = encodeURIComponent(pkg.receiver_phone);
				let sender_phone = encodeURIComponent(pkg.sender_phone);
				let location = encodeURIComponent(pkg.location);
				let package_price = pkg.price == 0 ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(pkg.price, pkg.price_currency));
				let fee = pkg.fee_responsible == "snd" ? "ទូទាត់រួច" : encodeURIComponent(this.config.moneylify(pkg.fee, pkg.fee_currency));
				this.$http.get(`https://localhost:8084/print?hash_id=${hash_id}&tracking=${tracking}&sender_phone=${sender_phone}&receiver_phone=${receiver_phone}&driver_phone=${driver_phone}&package_price=${package_price}&delivery_fee=${fee}&location=${location}&sender_name=${client_name}`).then(data => {
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/package/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "កញ្ចប់ឥវ៉ាន់ត្រូវបានលុបចេញពីបញ្ចីដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Deposits/View.vue